"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VulnerableCustomerPaymentHolidayRestrictionPage = exports.VulnerableCustomerPaymentHolidayRestrictionPagePlain = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var react_router_dom_1 = require("react-router-dom");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var VulnerableCustomerPaymentHolidayRestrictionPagePlain = /** @class */ (function (_super) {
    __extends(VulnerableCustomerPaymentHolidayRestrictionPagePlain, _super);
    function VulnerableCustomerPaymentHolidayRestrictionPagePlain(props) {
        var _this = _super.call(this, props) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates();
        return _this;
    }
    VulnerableCustomerPaymentHolidayRestrictionPagePlain.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "inner-cogntainer journey-content", children: [(0, jsx_runtime_1.jsx)("h1", { children: "Before You continue..." }), (0, jsx_runtime_1.jsx)("div", { className: "warning-banner restriction-banner-info mt-5", children: (0, jsx_runtime_1.jsx)("div", { className: "w-100", children: (0, jsx_runtime_1.jsx)("div", { className: "overflow-auto", children: (0, jsx_runtime_1.jsx)("div", { className: "inline-warning-text", children: "There is a payment that is pending collection. You will need to wait for this payment to be rejected at the bank before you can apply a payment holiday. Please try again once payment has been rejected and we\u2019ve triggered the Notice of Default with the 14 day cancellation notice." }) }) }) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/customers/".concat(this.props.params.id), className: "buttonLink mt-3 btn btn-primary plugin mt-5", children: "Ok, I understand" }), this.supportPortalTemplates.renderFooter()] }));
    };
    VulnerableCustomerPaymentHolidayRestrictionPagePlain = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], VulnerableCustomerPaymentHolidayRestrictionPagePlain);
    return VulnerableCustomerPaymentHolidayRestrictionPagePlain;
}(React.Component));
exports.VulnerableCustomerPaymentHolidayRestrictionPagePlain = VulnerableCustomerPaymentHolidayRestrictionPagePlain;
exports.VulnerableCustomerPaymentHolidayRestrictionPage = (0, components_1.withRouter)(VulnerableCustomerPaymentHolidayRestrictionPagePlain);
//# sourceMappingURL=VulnerableCustomerPaymentHolidayRestrictionPage.js.map